import { USER_SERVER } from "./constants";
import request from "./request";

export interface CheckLatestVersionResult {
    id: number;
    name: string;
    version: string;
    desc: string;
    status: string;
    md5: string;
    product: string;
    branch: string;
    software_id: string;
    download_url: string;
    package_size: number;
    platform_name: string;
    os_platform_name: string;
    add_time: any;
    update_time: any;
    depend_os_version: any;
    depend_device_version: string;
    update_force_flag: boolean;
    update_desc_list: UpdateDescList[];
    recommend_info: ExternalInfo;
    force_info: ExternalInfo;
}

export interface ExternalInfo {
    choose_all_flag: boolean;
    high_version: string;
    low_version: string;
    update_desc_list: UpdateDescList[];
}

export interface UpdateDescList {
    lan: string;
    desc: string;
    tip: string;
}

/**
 * 获取软件最新版本
 * @param {boolean} isFull 是否是全量包，默认true
 * @returns {Promise<CheckLatestVersionResult>}
 */
export const checkLatestVersion = (isFull = true): Promise<CheckLatestVersionResult> => {
    return request({
        url: USER_SERVER + "/sms/v1/software-latest",
        method: "POST",
        data: {
            product: isFull ? "Obsbot_Nexus" : "Obsbot_Nexus_Light",
            branch: "OA_E",
            os_platform_name: "Win_x64",
        },
    });
};

export interface ListRencentlyVersionInfoResult {
    pages: number;
    total: number;
    results: CheckLatestVersionResult[];
    page_no: number;
    page_size: number;
}

/**
 * 获取最近两次版本的信息
 * @returns {Promise<ListRencentlyVersionInfoResult>}
 */
export const checkRecentlyVersionInfo = (): Promise<ListRencentlyVersionInfoResult> => {
    return request({
        url: USER_SERVER + "/sms/v1/software/info-filtering",
        method: "POST",
        data: {
            product: "Obsbot_Nexus",
            page_no: 0,
            page_size: 2,
            start_time: "",
            end_time: "",
        },
    });
};
